import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import "../Amenities.css"

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import AppConfig from '../services/app-config';
import AuthService from '../services/auth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import EventBusyIcon from '@mui/icons-material/EventBusy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import appConfig from '../services/app-config';

import { useSwipeable } from 'react-swipeable';
import { motion, AnimatePresence } from 'framer-motion';

import PageHeader from '../components/PageHeader';

export default function Home({setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [activeReservations, setActiveReservations] = React.useState([]);
  const [pastReservations, setPastReservations] = React.useState([]);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [tabValue, setTabValue] = React.useState('active');
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [searchTerm, setSearchTerm] = React.useState('');
  const [showSearch, setShowSearch] = React.useState(false);
  const [swipeDirection, setSwipeDirection] = React.useState(null);
  const searchInputRef = React.useRef(null);
  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  
  let tab = new URLSearchParams(location.search).get('tab');

  
  const handleTabChange = (event,newValue) => {
    setTabValue(newValue);
    fetchInfo(newValue);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleToggleSearch = () => {
    setShowSearch((prev) => {
      const next = !prev;
      if (!next) {
        setSearchTerm('');
      }
      return next;
    });
  };

  function convertEpochsToTimeString(epoch1, epoch2) {
    const date1 = new Date(epoch1 * 1000);
    const date2 = new Date(epoch2 * 1000);

    const day = date1.getDate();
    const month = date1.toLocaleString('default', { month: 'short' });
    const time1 = date1.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const time2 = date2.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return `${day}/${month} ${time1} - ${time2}`;
  }

  const fetchInfo = (CurrentTabValue) => {
    setShowBackdrop(true);
    setLoading(true);

    apiClient.get(CurrentTabValue === 'active' ? 'reservations/active/list' : 'reservations/past/list', {}, { action: 'fetch_user_reservations' })
      .then(response => {
        if (response.status === 200) {
          if (CurrentTabValue === 'active') {
            
            const dataArray = Object.entries(response.data.data).map(([id, value]) => {
              const amenidadId = id.split('-')[0];
            return { id, ...value, amenity: amenidadId };
          });
          dataArray.sort((a, b) => a.inicio - b.inicio);
          setActiveReservations(dataArray);
          }
          else if (CurrentTabValue === 'past') {
            const dataArray = Object.entries(response.data.data).map(([id, value]) => {
              const amenidadId = id.split('-')[0];
              return { id, ...value, amenity: amenidadId };
            });
            dataArray.sort((a, b) => a.inicio - b.inicio);
            setPastReservations(dataArray.reverse());
          }
          setShowBackdrop(false);
          setLoading(false);
        }
      })
      .catch(error => {
        console.error('Error fetching reservations:', error);
        if (shouldRedirectToLogin(error)) {
          setRedirect({ trigger: true, route: '/login' })
        }
      });
  }

  React.useEffect(() => {
    setNavbarState({...navbarState, showBack: true, showOptions: false, showSearch: false})
    if (!AuthService.userRoleIncludes(["admin","receptor"])) {
      setRedirect({ trigger: true, route: '/amenidades' });
    }
    if (tab !== null) { 
      setRedirect({ trigger: true, route: '/amenidades' });
      setTabValue(tab);
    }
    fetchInfo(tabValue);
  }, [tabValue]);

  React.useEffect(() => {
    if (showSearch) {
      const timeoutId = setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
      return () => clearTimeout(timeoutId);
    }
  }, [showSearch]);

  const filterReservations = (reservations) => {
    return reservations.filter(reservation => 
      (reservation.nombre_amenidad?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false) ||
      (reservation.unidad?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false)
    );
  };

  const cardSx = {
    borderRadius: '10px',
    boxShadow: 0,
    border: '1px solid',
    borderColor: 'divider',
  };

  const renderReservations = (reservations) => {
    const filteredReservations = filterReservations(reservations);
    
    if (filteredReservations.length === 0) {
      return (
        <Card sx={{ ...cardSx, textAlign: 'center', py: 6 }}>
          <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
            <EventBusyIcon sx={{ fontSize: 56, color: 'text.secondary', mb: 2 }} />
            <Typography sx={{ fontSize: 16, fontWeight: 800, color: 'text.primary', mb: 1 }}>No hay reservaciones</Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>No hay ninguna reservación {tabValue === 'active' ? 'vigente' : 'pasada'} o ninguna coincide con tu búsqueda.</Typography>
          </CardContent>
        </Card>
      );
    }

    return (
      <Stack spacing={1.5}>
        {filteredReservations.map((reservation) => {
          const imageUrl = `${apiUrl}/img/amenities/${reservation.amenity}.jpg`;
          return (
            <Card
              key={reservation.id}
              sx={{ ...cardSx, cursor: 'pointer' }}
              onClick={() => setRedirect({ trigger: true, route: `/reservacion?id=${reservation.id}` })}
            >
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                  <Box
                    component="img"
                    src={imageUrl}
                    alt={reservation.nombre_amenidad ?? 'Amenidad'}
                    onError={(e) => { e.target.src = '/amenityplaceholder.png'; }}
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 2,
                      objectFit: 'cover',
                      flexShrink: 0,
                      backgroundColor: '#f0f0f0'
                    }}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'text.primary', mb: 0.4 }}>
                      {reservation.nombre_amenidad ?? 'N/A'}
                    </Typography>
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary', mb: 0.6 }}>
                      {reservation.unidad?.toUpperCase() ?? 'N/A'}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, mb: 0.8 }}>
                      <AccessTimeIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: 'text.secondary' }}>
                        {convertEpochsToTimeString(reservation.inicio, reservation.fin)}
                      </Typography>
                    </Box>
                    {tabValue === 'active' ? (
                      reservation.confirmada ? (
                        <Chip size="small" icon={<CheckCircleOutlineIcon sx={{ fontSize: 14 }} />} label="Confirmada" color="success" sx={{ fontWeight: 700, fontSize: 11 }} />
                      ) : (
                        <Chip size="small" icon={<EventBusyIcon sx={{ fontSize: 14 }} />} label="Pendiente de Confirmación" color="warning" sx={{ fontWeight: 700, fontSize: 11 }} />
                      )
                    ) : (
                      <Chip size="small" icon={<CheckCircleOutlineIcon sx={{ fontSize: 14 }} />} label="Pasada" sx={{ fontWeight: 700, fontSize: 11 }} />
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Stack>
    );
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (tabValue === 'active') {
        setSwipeDirection('left');
        setTabValue('past');
      }
    },
    onSwipedRight: () => {
      if (tabValue === 'past') {
        setSwipeDirection('right');
        setTabValue('active');
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const pageVariants = {
    enter: (direction) => {
      return {
        x: direction === 'left' ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        x: direction === 'left' ? -1000 : 1000,
        opacity: 0
      };
    }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
  };

  return (
    <Container maxWidth="sm" disableGutters {...swipeHandlers}>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <Snackbar open={snackbar.open} autoHideDuration={8000} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', pb: 10 }}>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            px: 3,
            pt: 1.5,
            pb: 0.5,
            bgcolor: 'background.default'
          }}
        >
            <Box sx={{ mb: 2 }}>
              <PageHeader
                title="Reservaciones"
                icon="calendar"
                onBack={() => navigate(-1)}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: showSearch ? 1.25 : 1.5 }}>
            <Stack direction="row" spacing={1} sx={{ overflowX: 'auto', pb: 0.5, flexGrow: 1 }}>
              <Chip
                label="Vigentes"
                clickable
                color={tabValue === 'active' ? 'primary' : 'default'}
                variant={tabValue === 'active' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'active')}
                sx={{ fontWeight: 700 }}
              />
              <Chip
                label="Pasadas"
                clickable
                color={tabValue === 'past' ? 'primary' : 'default'}
                variant={tabValue === 'past' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'past')}
                sx={{ fontWeight: 700 }}
              />
            </Stack>
            <IconButton
              onClick={handleToggleSearch}
              sx={{
                width: 40,
                height: 40,
                borderRadius: '10px',
                border: '1px solid',
                borderColor: 'divider',
                color: 'text.primary',
                flexShrink: 0,
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
          {showSearch && (
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Buscar por amenidad o unidad"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              inputRef={searchInputRef}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: { borderRadius: '8px' }
              }}
            />
          )}
        </Box>

        <Box sx={{ px: 3, mt: 1.5 }}>
          <AnimatePresence initial={false} custom={swipeDirection}>
            <motion.div
              key={tabValue}
              custom={swipeDirection}
              variants={pageVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={pageTransition}
            >
              {!loading && (
                tabValue === "past" ? renderReservations(pastReservations) : renderReservations(activeReservations)
              )}
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
    </Container>
  );
}